export enum EditorType {
  default,
  title,
  subTitle,
  paragraph,
  segment,
  notice,
  note
}
